import { render, staticRenderFns } from "./DatatableNegociation.vue?vue&type=template&id=13363e9b"
import script from "./DatatableNegociation.vue?vue&type=script&lang=js"
export * from "./DatatableNegociation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports